import Text from '@loggi/ui/components/text';
import TextInput from '@loggi/ui/components/text-input';
import colors from '@loggi/ui/components/utils/colors';
import View from '@loggi/ui/components/view';
import get from 'lodash/get';
import PropTypes from 'prop-types';
import React, { Component, Fragment } from 'react';
import cpfCnpj from 'shared/formatters/cpf-cnpj';
import RemainingAttempts from '../remaining-attempts/remaining-attempts.component';
import styles from './auth-input.styles.scss';

const CNPJ_LENGTH = 14;
export const MASKED_CNPJ_LENGTH = CNPJ_LENGTH + 4;
export const INPUT_PLACEHOLDER_TEXT = 'Digite seu CPF ou CNPJ';

export default class AuthInput extends Component {
  static displayName = 'AuthInput';

  static propTypes = {
    inputNifValue: PropTypes.string,
    invalidCpfOrCnpj: PropTypes.bool,
    cpfOrCnpjNotFound: PropTypes.bool,
    inputErrorText: PropTypes.string,
    remainingAttempts: PropTypes.number,
    onChange: PropTypes.func.isRequired,
    onKeyPress: PropTypes.func.isRequired
  };

  static defaultProps = {
    inputNifValue: '',
    invalidCpfOrCnpj: false,
    cpfOrCnpjNotFound: false,
    inputErrorText: null,
    remainingAttempts: null
  };

  constructor(props) {
    super(props);
    this.state = {
      onInputPaste: false
    };
    this.textInput = React.createRef();
  }

  componentDidUpdate() {
    const { inputNifValue } = this.props;
    // Way to partially fix the behavior that set the cursor position to the end of input
    if (inputNifValue.length > 0) {
      this._updateInputCursor();
    }
  }

  _updateInputCursor = () => {
    // Get the input value length and its cursor position after the change
    const inputNode = (this, 'textInput.current', null);

    if (!inputNode) {
      return;
    }

    const { inputNifValue } = this.state;
    const oldInputValueLength = inputNode.value.length;
    const cursorPositionAfterInputChange = inputNode.selectionStart;
    // Set the value to input and get its length again
    inputNode.value = inputNifValue;
    const newInputValueLength = inputNode.value.length;
    // Set the input cursor position according to the position after the change
    const newIdx = Math.max(
      0,
      newInputValueLength - oldInputValueLength + cursorPositionAfterInputChange
    );
    inputNode.selectionStart = newIdx;
    inputNode.selectionEnd = inputNode.selectionStart;
  };

  _maskInputValue = value => {
    const { onInputPaste } = this.state;

    const inputNifValue = onInputPaste
      ? cpfCnpj.onPasteFormatter(value)
      : cpfCnpj.onMaskedValueFormatter(value);

    return inputNifValue;
  };

  _handleInputChange = e => {
    const inputValue = e.target.value.trim();
    const maskedInputValue = this._maskInputValue(inputValue);
    const { onChange } = this.props;

    this.setState({
      inputNifValue: maskedInputValue
    });

    onChange(maskedInputValue);
  };

  render() {
    const {
      invalidCpfOrCnpj,
      cpfOrCnpjNotFound,
      inputErrorText,
      remainingAttempts,
      onKeyPress
    } = this.props;

    const { inputNifValue } = this.state;

    const shouldRenderInputWithErrorMessage =
      invalidCpfOrCnpj || cpfOrCnpjNotFound;

    const textInput = get(this, 'textInput.current', null);
    if (invalidCpfOrCnpj && textInput) textInput.blur();

    const shouldRenderRemainingAttemptsMessage = remainingAttempts > 0;
    return (
      <Fragment>
        {shouldRenderRemainingAttemptsMessage && (
          <RemainingAttempts remainingAttempts={remainingAttempts} />
        )}
        <View
          className={
            shouldRenderInputWithErrorMessage ? styles.errorBorder : ''
          }
        >
          <TextInput
            // Workaround: type "tel" because the TextInput doesn't accept type "number"
            type="tel"
            status={shouldRenderInputWithErrorMessage ? 'danger' : null}
            value={inputNifValue}
            placeholder={INPUT_PLACEHOLDER_TEXT}
            inputProps={{
              'data-hj-whitelist': true,
              ref: this.textInput,
              maxLength: MASKED_CNPJ_LENGTH,
              onChange: this._handleInputChange,
              onKeyPress,
              onPaste: () => this.setState({ onInputPaste: true })
            }}
          />
        </View>
        {shouldRenderInputWithErrorMessage && (
          <View className={styles.inputErrorMessage}>
            <Text small bold color={colors.type.DANGER}>
              {inputErrorText}
            </Text>
          </View>
        )}
      </Fragment>
    );
  }
}
